import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
import get from 'lodash/get';

import Thumbnail from './Thumbnail';

const vjsComponent = videojs.getComponent('Component');

const setupThumbnail = async (xingPlayer, sprites) => {
  const vttSrc = sprites[1].source;
  const mouseTimeDisplay =
    xingPlayer.videojs.controlBar.progressControl.seekBar.mouseTimeDisplay;
  const timeToolipEl = get(mouseTimeDisplay, 'timeTooltip.el_');
  const vttResponse = await fetch(vttSrc, { method: 'get' });
  const vtt = await vttResponse.text();

  if (timeToolipEl) {
    mouseTimeDisplay.addChild(
      new ThumbnailContainer(xingPlayer, timeToolipEl, vtt, vttSrc),
      {},
      1
    );
  }
};

class ThumbnailContainer extends vjsComponent {
  constructor(xingPlayer, timeToolipEl, vtt, vttSrc) {
    super(xingPlayer.videojs);

    this.vtt = vtt;
    this.vttSrc = vttSrc;
    this.timeToolipEl = timeToolipEl;

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);
    /* When player is ready, call method to mount React component */
    xingPlayer.videojs.ready(() => {
      this.mount();
    });

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el());
    });
  }

  mount() {
    ReactDOM.render(
      <Thumbnail
        timeToolipEl={this.timeToolipEl}
        vtt={this.vtt}
        vttSrc={this.vttSrc}
      />,
      this.el()
    );
  }
}

export default setupThumbnail;
